/**
 * The return address to hand Plaid when Link restarts after a bank's own sign-in page (OAuth).
 *
 * Plaid checks it against the redirect URI the link token was made with, plus the oauth_state_id it added. The page
 * the person actually lands on is not that address: app.gocarrera.com forwards to app.tradetap-pro.com on the web,
 * and the phone app runs on localhost. So when the configured address is known, rebuild it from that and the state.
 */
export function plaidReceivedRedirectUri(configured: string | undefined, received: string, origin: string): string {
  const url = new URL(received, origin);
  const state = url.searchParams.get('oauth_state_id');
  if (!configured || !state) {
    return url.origin === origin ? origin + url.pathname + url.search : url.toString();
  }
  const rebuilt = new URL(configured);
  rebuilt.search = new URLSearchParams({ oauth_state_id: state }).toString();
  return rebuilt.toString();
}

/** A link a bank's sign-in page sent back, as opposed to a sign-in (Auth0) callback. */
export const isPlaidOAuthReturn = (url: string | undefined): boolean => !!url && url.includes('oauth_state_id=');
